import { render, staticRenderFns } from "./TaxesOfColumn.vue?vue&type=template&id=5054c314&"
import script from "./TaxesOfColumn.vue?vue&type=script&lang=js&"
export * from "./TaxesOfColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports